import request from '@/utils/api/request';

export const getFileIdAfterUploading = async ({ file, url }) => {
  let id = null;
  try {
    let fd = new FormData();
    fd.set('file', file);
    const { data } = await request.post(url, fd);
    id = data.id;
  } catch (e) {
    console.error(e);
  }
  return id;
};

export default { getFileIdAfterUploading };
